import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const TermsPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center" fontWeight="bold">
          TERMOS E CONDIÇÕES GERAIS DE USO DA PLATAFORMA ADVOGADA PARCEIRA
        </Typography>
        
        <Typography variant="subtitle1" gutterBottom align="center" fontStyle="italic" color="error">
          Lembrete: Ao utilizar a Plataforma, a Usuária concorda integralmente com estes Termos de Uso. Em caso de discordância com os termos aqui estabelecidos, recomenda-se a não utilização da Plataforma.
        </Typography>
        
        <Box mt={3}>
          <Typography variant="body1" paragraph>
            Bem-vinda(o) à plataforma Advogada Parceira.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Estes Termos e Condições Gerais de Uso (os "Termos de Uso") regem o uso da plataforma Advogada Parceira ("Plataforma"), desenvolvida pela Parceira Tecnologia Ltda. ("Advogada Parceira"), inscrita no CNPJ/MF sob o nº 60.060.220/0001-32.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Estes Termos de Uso aplicam-se a todas as usuárias da Plataforma, assim entendidas como as pessoas físicas ou jurídicas que assinarem um dos pacotes oferecidos pela Advogada Parceira (as "Usuárias"). Pedimos, portanto, que as Usuárias leiam e manifestem sua concordância com o conteúdo destes Termos de Uso.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Ao examinar os Termos de Uso e começar a usar a Plataforma, a Usuária está ciente e concorda integralmente com todas as regras e condições aqui estabelecidas. Caso haja alguma dúvida sobre qualquer aspecto deste documento, por favor entre em contato com o suporte pelo e-mail suporte@advogadaparceira.com.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Se, porventura, a Usuária não concordar com qualquer disposição destes Termos de Uso, recomenda-se que evite o uso da Plataforma. A desconsideração desta recomendação será considerada como concordância com as consequências resultantes de eventual uso indevido.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Dos Serviços Prestados pela Plataforma
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Plataforma oferece um serviço meramente referencial, destinado ao auxílio e orientação das Usuárias (i) ao auxílio e orientação das Usuárias na realização de pesquisas e análises jurídicas; e (ii) na produção, elaboração e gestão de peças processuais e documentos jurídicos com auxílio de inteligência artificial ("IA"). A Plataforma também disponibiliza outros serviços que utilizam funcionalidades de inteligência artificial – com o objetivo de facilitar a compreensão de informações jurídicas –, incluindo movimentações e andamentos processuais. Ao utilizar a Plataforma, a Usuária declara que é advogada e possui conhecimentos e habilidades técnicas adequadas para operar a Plataforma.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Ao utilizar a Plataforma, a Usuária reconhece que os resultados e informações fornecidos não substituem o aconselhamento jurídico de um profissional qualificado. Além disso, a Usuária está ciente de que a utilização da Plataforma não deve ser considerada como uma substituição ao trabalho, à expertise ou às funções de um(a) advogado(a) devidamente licenciado(a).
          </Typography>
          
          <Typography variant="body1" paragraph>
            É fundamental que a Usuária compreenda plenamente que a Plataforma <strong>NÃO</strong> realiza atividades correlatas à advocacia, e não presta nenhuma forma de assessoria, aconselhamento, consultoria ou qualquer outra atividade profissional relacionada à prática jurídica. Sua função se limita estritamente a auxiliar a Usuária em pesquisas e análises jurídicas, bem como na redação e gestão de peças jurídicas com o suporte e auxílio de inteligência artificial. A orientação profissional adequada e apropriada deve ser sempre fornecida exclusivamente por profissionais do direito devidamente licenciados para tais atividades.
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom mt={3} fontWeight="bold">
            Dos serviços e funcionalidades oferecidos pela Plataforma Advogada Parceira
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Advogada Parceira presta três principais tipos de serviços, nos quais estão incluídas as funcionalidades disponibilizadas na Plataforma. São eles: (a) criação de minutas de peças e documentos jurídicos (com ou sem auxílio de IA); (b) serviços de auxílio à advocacia e outras profissões jurídicas; e (c) gestão de documentos jurídicos (com ou sem auxílio de IA). As funcionalidades poderão ser disponibilizadas nos planos existentes para contratação na Plataforma, e são condicionadas a limitações de uso conforme o plano contratado.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>1.4.1.</strong> Da criação de minutas de peças e documentos jurídicos (com ou sem auxílio de IA): A Plataforma possibilita, mediante contratação de um dos planos disponibilizados (e conforme as suas limitações), a criação de minutas de peças e documentos jurídicos – com ou sem auxílio de inteligência artificial.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>1.4.2.</strong> Da gestão de documentos jurídicos (com ou sem auxílio de IA): A Plataforma possibilita, mediante contratação de um dos planos disponibilizados (e conforme as suas limitações), a gestão de documentos jurídicos (com ou sem auxílio de IA). Com a gestão de documentos, as Usuárias poderão (conforme as limitações do plano contratado): realizar o repositório, melhorar seus documentos com IA, duplicar documentos, reescrever documentos com IA na edição (o que pode envolver, a título de exemplo, interações como o upload, salvamento, edição, duplicação e exclusão de documentos).
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>1.4.3.</strong> Das outras funcionalidades de auxílio à advocacia e profissões jurídicas: além de funcionalidades de criação e gestão de documentos, a Plataforma possibilita, também, mediante contratação de um dos planos disponibilizados (e conforme as suas limitações), o uso de outras funcionalidades para auxílio referencial à advocacia e às profissões jurídicas. Dentre essas funcionalidades previstas nas cláusulas acima, citamos a ferramenta de busca de jurisprudências, por exemplo.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Do Cadastro e Assinatura da Plataforma
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom mt={3} fontWeight="bold">
            Cadastro e Restrições de Acesso
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>2.1.</strong> O cadastro e a utilização da Plataforma destinam-se exclusivamente a advogados(as) ou entidades jurídicas (tais como escritórios de advocacia). É absolutamente proibida qualquer forma de tentativa de automação ou tentativa de engenharia reversa nas consultas ao conteúdo gerado pela Plataforma.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>2.2.</strong> Ao submeter-se ao cadastro, as Usuárias declaram possuir a capacidade legal e civil necessária para contratar os serviços da Plataforma, mediante a aceitação dos presentes Termos de Uso.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>2.3.</strong> Após o preenchimento adequado das informações solicitadas no Cadastro e/ou no perfil da Usuária, a Plataforma criará uma conta associada a um login e a uma senha individuais para cada Usuária. O login corresponderá ao endereço de e-mail fornecido e será utilizado para acessar a área restrita da conta e as funcionalidades da Plataforma.
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom mt={3} fontWeight="bold">
            Planos de Assinatura, Pagamento e Faturamento
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>2.4.</strong> A Plataforma oferece diversos planos de assinatura, detalhados na página de planos. Para acessar os recursos pagos, é necessário adquirir uma assinatura de um dos planos oferecidos, disponíveis para as recorrências mensal e anual, conforme a escolha da Usuária.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Dos Direitos de Propriedade Intelectual
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>3.1.</strong> É absolutamente proibida qualquer forma de tentativa de automação ou tentativa de engenharia reversa na Plataforma, seu conteúdo e/ou no conteúdo gerado pela Plataforma.
          </Typography>
          
          <Typography variant="body1" paragraph>
            <strong>3.2.</strong> A Usuária reconhece e concorda que qualquer propriedade intelectual desenvolvida pela Advogada Parceira, de forma ampliada ou beneficiada, será de exclusiva propriedade e fruição da Advogada Parceira, inclusive aquelas desenvolvidas a partir de sugestões, reclamações, dentre outras interações com Usuárias, por meio de quaisquer canais de comunicação. A Usuária, neste ato, renuncia a qualquer direito ou reivindicação que possa ter em relação a qualquer aspecto legal ou negocial da propriedade.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Das Responsabilidades
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom mt={3} fontWeight="bold">
            Responsabilidades da Usuária
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Usuária assente que a Plataforma é uma ferramenta auxiliar e de utilização meramente referencial, que não substitui o trabalho, o conhecimento e a responsabilidade da Usuária na sua análise jurídica para tomada de decisões, no seu dever de pesquisa a fontes legais, jurisprudenciais e doutrinárias e na elaboração das peças processuais e documentos jurídicos correlatos. É de responsabilidade da Usuária revisar e validar o conteúdo gerado pela Plataforma antes de sua utilização.
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom mt={3} fontWeight="bold">
            Responsabilidade da Advogada Parceira
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Advogada Parceira se compromete a orientar, coordenar e supervisionar internamente o adequado funcionamento da Plataforma, bem como a manter a equipe atuando constantemente no aperfeiçoamento da Plataforma, com objetivo de prevenir, reparar e abrandar eventuais problemas técnicos decorrentes do funcionamento da Plataforma. A Advogada Parceira não se responsabiliza por eventuais erros que possam ser notados no conteúdo, na utilização da plataforma e nem por eventuais oscilações de acesso relacionadas à prestação de intermediadores.
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom mt={3} fontWeight="bold">
            Limitação de Responsabilidade
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Advogada Parceira não assume nenhuma responsabilidade por quaisquer danos às Usuárias, sejam diretos, indiretos, acidentais, especiais ou consequentes, resultantes do uso ou incapacidade de uso da Plataforma.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Da Confidencialidade
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Plataforma obriga-se a manter o sigilo sobre os dados que sejam considerados como sigilosos pela legislação vigente, e que tenham sido fornecidos pelas Usuárias ao realizar seu Cadastro (os "Dados Confidenciais").
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Plataforma não poderá, sob qualquer pretexto, divulgar, revelar, reproduzir, utilizar ou dar conhecimento dos Dados Confidenciais a terceiros, exceto com o prévio consentimento da Usuária, nem utilizar as informações para fins diversos ao objeto do presente instrumento e do serviço contratado.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Para mais informações sobre o tratamento dado pela Advogada Parceira aos dados compartilhados pelas Usuárias, favor consultar a nossa Política de Privacidade.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Encerramento de Conta
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Advogada Parceira se reserva ao direito de encerrar ou suspender a conta de qualquer Usuária que violar estes Termos.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Contato
          </Typography>
          
          <Typography variant="body1" paragraph>
            Para entrar em contato conosco em relação a estes Termos de Uso, envie um e-mail para suporte@advogadaparceira.com.
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom mt={4} fontWeight="bold">
            Disposições Gerais
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom mt={3} fontWeight="bold">
            Modificação dos Termos de Uso
          </Typography>
          
          <Typography variant="body1" paragraph>
            A Advogada Parceira se reserva ao direito de modificar ou atualizar estes Termos de Uso a qualquer momento. As alterações entrarão em vigor imediatamente após a publicação dos Termos de Uso revisados na Plataforma. É responsabilidade da Usuária revisar os Termos periodicamente.
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom mt={3} fontWeight="bold">
            Independência das Partes
          </Typography>
          
          <Typography variant="body1" paragraph>
            As Partes reconhecem que, por força deste instrumento, não se estabelece qualquer tipo de sociedade, parceria ou qualquer forma de associação ou relação contratual de mandato entre elas que possa autorizar a Usuária a agir como representante da Plataforma Advogada Parceira.
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom mt={3} fontWeight="bold">
            Invalidade Parcial
          </Typography>
          
          <Typography variant="body1" paragraph>
            A declaração de nulidade, invalidade ou ineficácia de qualquer das disposições contidas no presente instrumento não prejudicará a validade e eficácia das demais, que permanecerão em vigor, como se a disposição nula, inválida ou ineficaz tivesse sido separada e excluída.
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom mt={3} fontWeight="bold">
            Concordância
          </Typography>
          
          <Typography variant="body1" paragraph>
            Ao utilizar a Plataforma, a Usuária concorda integralmente com estes Termos de Uso. Caso não concorde com os termos aqui estabelecidos, recomenda-se que não utilize a Plataforma.
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom mt={3} fontWeight="bold">
            Foro
          </Typography>
          
          <Typography variant="body1" paragraph>
            Fica eleito o foro da Cidade de Rio Claro, Estado de São Paulo, para dirimir quaisquer questões oriundas deste instrumento.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default TermsPage; 